import React from "react";
import PropTypes from "prop-types";

export default function StudioSelectionPanel({
  selectedCount = 0,
  onClearSelection = null,
}) {
  return (
    <section className="studio-framework-inspector__panel">
      <p className="studio-framework-inspector__eyebrow">Sélection</p>

      <p className="studio-framework-inspector__selection-count">
        {selectedCount} élément(s) sélectionné(s)
      </p>

      <button
        type="button"
        className="studio-framework-inspector__action studio-framework-inspector__action--ghost"
        onClick={onClearSelection}
        disabled={selectedCount === 0 || !onClearSelection}
      >
        Désélectionner
      </button>
    </section>
  );
}

StudioSelectionPanel.propTypes = {
  selectedCount: PropTypes.number,
  onClearSelection: PropTypes.func,
};
